import styled from "styled-components";

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
    visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
    transition: all 0.3s ease-in-out;
`;

export const ModalContainer = styled.div`
    background: linear-gradient(135deg, #0a0014 0%, #1a0533 30%, #4a1c6b 70%, #8b2fc9 100%);
    border-radius: 15px;
    padding: 40px;
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    transform: ${({ $isOpen }) => ($isOpen ? 'scale(1)' : 'scale(0.8)')};
    transition: all 0.3s ease-in-out;
    border: 1px solid rgba(200, 64, 233, 0.3);
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 20px;
    background: transparent;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    transition: all 0.2s ease;

    &:hover {
        color: #B05FFD;
        transform: rotate(90deg);
    }
`;

export const ModalTitle = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 10px;
`;

export const ModalSubtitle = styled.p`
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 30px;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.label`
    font-size: 0.9rem;
    font-weight: 600;
    color: #fff;
`;

export const Input = styled.input`
    padding: 12px 15px;
    border: 2px solid rgba(176, 95, 253, 0.3);
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.2s ease;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
        outline: none;
        border-color: #B05FFD;
        background: rgba(255, 255, 255, 0.15);
    }
`;

export const TextArea = styled.textarea`
    padding: 12px 15px;
    border: 2px solid rgba(176, 95, 253, 0.3);
    border-radius: 8px;
    font-size: 1rem;
    min-height: 120px;
    resize: vertical;
    font-family: inherit;
    transition: all 0.2s ease;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
        outline: none;
        border-color: #B05FFD;
        background: rgba(255, 255, 255, 0.15);
    }
`;

export const SubmitButton = styled.button`
    padding: 14px 30px;
    background: #B05FFD;
    color: #fff;
    border: none;
    border-radius: 50px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 10px;

    &:hover {
        background: #9333ea;
        transform: translateY(-2px);
    }

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
        transform: none;
    }
`;

export const SuccessMessage = styled.div`
    text-align: center;
    padding: 20px;

    h3 {
        color: #22c55e;
        font-size: 1.5rem;
        margin-bottom: 10px;
    }

    p {
        color: rgba(255, 255, 255, 0.8);
    }
`;

export const ErrorMessage = styled.p`
    color: #ef4444;
    font-size: 0.85rem;
    margin-top: -10px;
`;
